import { render, staticRenderFns } from "./siNo.vue?vue&type=template&id=6b8aecbd"
import script from "./siNo.vue?vue&type=script&lang=js"
export * from "./siNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports